import React from 'react';
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types';
import {
  FormGroup,
  InputGroup,
  Button,
  ButtonToolbar,
  ControlLabel,
  FormControl,
  HelpBlock,
  Table

} from 'react-bootstrap';
import { Form, Field } from 'react-final-form';
import { required, number, positiveNumber } from '../../../forms';
import { convertFromRaw, convertToRaw, EditorState } from 'draft-js';
import { left, center, right, justify, Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import RoomsPhotosForm from './RoomsPhotosForm';

const Error = ({ name }) => (
  <Field
    name={name}
    subscription={{ touched: true, error: true }}
    render={({ meta: { touched, error } }) =>
      touched && error ? <span className="alert-danger">{error}</span> : null
    }
  />
);
export const requiredRoomType = value => (value ? undefined : 'Room Type is Required');
export const renderTextField = ({ input, label, type, meta: { touched, error, warning }, className }) => (
  <InputGroup>
    {label && (<ControlLabel>{label}</ControlLabel>)}
    <FormControl
      {...input}
      type={type}
    />
  </InputGroup>
);

function getInitialEditorState(content) {
  if (!content) {
    return EditorState.createEmpty();
  }
  if (Object.keys(content).length === 0 && content.constructor === Object) {
    return EditorState.createEmpty();
  }
  return EditorState.createWithContent(convertFromRaw(content));
}


class RoomsForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handlegetPhoto = this.handlegetPhoto.bind(this);
    //this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      show: false,
    };
    const editorState = getInitialEditorState();

    this.state = {
      editorState,
      pristine: true,
      editorData: { value: "" },
      photos: "",

    };
  }

  handlegetPhoto(Values) {
    /*console.log('handlegetPhoto')
    debugger
    this.props.addHotelAddRoomType(Values) */


    // this.setState({ photos: Values }, () =>
    //   console.log(this.state.photos));
  }


  onEditorStateChange: Function = editorState => {
    this.setState({
      editorState,
      pristine: false,
    });
  };

  onBlurEvent: Function = temp => {
    let data = convertToRaw(this.state.editorState.getCurrentContent());
    //this.props.handleData(data);
    //debugger;
    // this.setState({
    //   editorData:{value : data},
    //   pristine: false,
    // });
    this.setState({ editorData: data }, () =>
      console.log(this.state.editorData));

  }

  onSubmit = (values) => {
    let desc = this.state.editorData;
    let data = {
      room_type: values.room_type,
      description: desc,
      hotel: this.props.hotel.id
    }
    if (this.props.ishotelView) {
      this.props.addHotelAddRoomType(data, (response) => {
        this.props.openModal(response.id)
      })
    } else {
      this.props.handleSubmit(data)
    }

    const editorState = getInitialEditorState();
    this.setState({ show: false, editorState, editorData: { value: '' } });
  }
  handleSubmit(values) {
    //debugger;
    const initialValues = this.props.tour;
    const isNew = this.props.tour.id ? false : true;
    if (isNew) {
      return this.handleAddTour(values, initialValues);
    }
    return this.handleEditTour(values, initialValues);
  }

  handleClose() {
    const editorState = getInitialEditorState();
    this.setState({ show: false, editorState, editorData: { value: '' } });
  }

  handleShow() {
    this.setState({ show: true });
  }

  render() {
    const errors = {};
    const pristine = "";
    const { editorState } = this.state;
    return (
      <div className="row">
        <div className="col-md-11">
          <h1 className="hotel-detail-subhead">
            Rooms
                </h1>
        </div>
        <div className="col-md-1" style={{ marginTop: 40 }}>
          <FormGroup>
            <ButtonToolbar>
              <Button bsStyle="success" onClick={this.handleShow}>
                Add
          </Button>
            </ButtonToolbar>
          </FormGroup>
        </div>

        <Modal show={this.state.show} onHide={this.handleClose} dialogClassName="hotel-room-modal">
          <Modal.Header closeButton>
            <Modal.Title>Add Room</Modal.Title>
          </Modal.Header>
          <div id="modal-body" className="room-modal">
            <Modal.Body>
              <Form
                onSubmit={this.onSubmit}
                render={({ handleSubmit, pristine, invalid }) => (
                  <form onSubmit={handleSubmit} >
                    <div id="add_room_div">
                      <div className="row">
                        <FormGroup>
                          <Field
                            name="room_type"
                            type="text"
                            component={renderTextField}
                            label="Room Type"
                            placeholder=""
                            bsClass="hotel-highlight"
                            validate={requiredRoomType}
                          />
                          <Error name="room_type" />
                        </FormGroup>
                      </div>
                      <div className="row">
                        <div className="col-md-12 hotel-details-description">
                          <h4 className="hotel-highlight">Description</h4>

                          <Editor
                            editorState={editorState}
                            toolbarClassName="toolbarClassName"
                            wrapperClassName="wrapperClassName"
                            editorClassName="editorClassName"
                            toolbar={{
                              options: ['inline', 'blockType', 'list', 'textAlign', 'history'],
                              inline: {
                                options: ['bold', 'italic', 'underline'],
                              },
                              blockType: {
                                options: ['Normal', 'H1', 'H2'],
                                className: 'fontSizeDrop',
                              },
                              textAlign: {
                                options: ['left', 'center', 'right'],
                              },
                            }}
                            onEditorStateChange={this.onEditorStateChange}
                            onBlur={this.onBlurEvent}
                          />
                        </div>
                      </div>
                      {/* <div className="row">
                        <RoomsPhotosForm
                          {...this.props}
                          handleClose={this.handleClose}
                          handlegetPhoto={this.handlegetPhoto}
                          isRoomForms={true}
                        />
                      </div> */}


                      {errors !== undefined && errors.FORM_ERROR && (
                        <p className="alert alert-danger">{errors.FORM_ERROR}</p>
                      )}
                      {errors !== undefined && errors.note && (
                        <p className="alert alert-danger">{errors.note}</p>
                      )}
                      <FormGroup>
                        <ButtonToolbar className="ismiddle">
                          <Button
                            disabled={false}
                            bsStyle="success"
                            type="submit"

                          >
                            Save
                                </Button>
                          <Button
                            disabled={false}
                            bsStyle="success"
                            onClick={this.handleClose}
                          >
                            Cancel
                                </Button>
                        </ButtonToolbar>
                      </FormGroup>
                    </div>
                  </form>
                )}
              />
            </Modal.Body>
          </div>
          <Modal.Footer>
          </Modal.Footer>
        </Modal>


      </div>

    );
  }
}



export default RoomsForm;
  //render(<Example />);


// WEBPACK FOOTER //
// src/routes/hotels/components/RoomsForm.js